import { periodMappings } from "@/app/bullion/type-constants";

const SkeletonAssetInfo = () => {
    return (
        <>
            <p className="section-chart-title animate-pluse mt-1 h-7 w-[60%] rounded-round bg-neutral-100 text-4xl font-semibold leading-[130%] tracking-[-0.48px] text-neutral-900">
                &nbsp;
            </p>

            <div className="mt-3 flex justify-between">
                <div className="align-items-center mb-8 flex sm:mb-4">
                    <div className="mr-2 h-5 w-20 animate-pulse rounded-round bg-neutral-100"></div>
                    <div className="mr-2 h-5 w-20 animate-pulse rounded-round bg-neutral-100"></div>
                </div>
            </div>

            <section className="viz-section-width">
                <div className="relative h-[320px] w-full">
                    &nbsp;
                </div>
            </section>

            <div className="flex flex-wrap justify-center gap-4 pb-4 pt-6 sm:py-3">
                {periodMappings.map(({ key }, index) => {
                    return index ? (
                        <button
                            key={key}
                            className={`mx-sm-3 h-8 w-14 animate-pulse text-nowrap rounded-round bg-neutral-100 px-3 py-[6px] sm:mx-1 sm:px-4`}
                            disabled
                        ></button>
                    ) : null;
                })}
            </div>
        </>
    );
};
export default SkeletonAssetInfo;
